<template>
  <Button
    :type="type"
    :disabled="disabled"
    :icon="icon"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <span v-if="label">{{ label }}</span>
  </Button>
</template>

<script setup lang="ts">
import Button from 'primevue/button'

defineProps<{
  label?: string
  icon?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}>()

defineEmits<{ (e: 'click', ev: MouseEvent): void }>()
</script>
